// (async () => {

//     const { Core } = await importModule('Core');

//     customElements.define('product-options-dropdown', class extends Core {
//         elements = {
//             dropdown: 'drop-down',
//             current: '[data-current]'
//         }

//         render() {
//             this._handleChange();
//         }

//         _handleChange() {
//             this.addEventListener('change', this._onChange.bind(this));
//         }

//         _onChange({ target }) {
//             this.$current.textContent = target.value;
//             this.$dropdown.close();
//         }
//     });

// })();

(async () => {
  const { Core } = await importModule('Core');

  customElements.define('product-options-dropdown', class extends Core {
    elements = {
      dropdown: 'drop-down',
      current: '[data-current]'
    }

    render() {
      this._handleChange();
      this._handleItemClick();
    }

    _handleChange() {
      this.addEventListener('change', this._onChange.bind(this));
    }

    _onChange({ target }) {
      this.$current.textContent = target.value;
      this.$dropdown.close();
    }

    _handleItemClick() {
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.product-options-dropdown-item-link');
        if (link && link.hasAttribute('item-url')) {
          const url = link.getAttribute('item-url');
          if (url) {
            window.location.href = url;
          }
        }
      });
    }
  });
})();